const PASSWORD_MIN_LENGTH = 8;

export default PASSWORD_MIN_LENGTH;
